import { render, staticRenderFns } from "./SiparisListesi.vue?vue&type=template&id=28a836ec&scoped=true&"
import script from "./SiparisListesi.vue?vue&type=script&lang=js&"
export * from "./SiparisListesi.vue?vue&type=script&lang=js&"
import style0 from "./SiparisListesi.vue?vue&type=style&index=0&id=28a836ec&lang=scss&scoped=true&"
import style1 from "./SiparisListesi.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a836ec",
  null
  
)

export default component.exports